<template>
  <section class="hero">
    <div class="hero-body">
      <div class="columns">
        <div class="column">
          <h3 class="title">
            <span class="icon">
              <i class="mdi mdi-email"></i>
            </span>
            Sign In
          </h3>          
        </div>
        <div class="column">
           <form name="user-signup">
              <div class="field hidden" for="name">
                <label class="label">name</label>
                <div class="control">
                  <input class="input" type="name" name="name" placeholder="name" maxlength=30 v-model="name"></input>
                </div>
              </div>
              <div class="field" for="email">
                <label class="label">Email</label>
                <div class="control">
                  <input class="input" type="email" name="email" placeholder="email" maxlength=30 v-model="email" required></input>
                </div>
              </div>
              <div class="field" for="password">
                <label class="label">Password</label>
                <div class="control">
                  <input class="input" type="password" name="password" placeholder="password" maxlength=30 v-model="password" required></input>
                </div>
              </div>
              <button class="button" :class="{'is-loading': loading}" :disabled="disabled" @click.prevent="onSubmit">Sign Up</button>
              <section class="section">
                <p>Already have an account? <a href="/user/signin">Sign in!</a></p>
                <div class="notification is-danger" v-if="error">{{error.message}}</div>
              </section>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "UserSignup",
  data() {
    return {
      email: "",
      password: ""
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    error() {
      return this.$store.getters.error;
    },
    loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user(value) {
      if (value !== null && value !== "undefined") {
        this.$router.push("/");
      }
    }
  },
  methods: {
    onSubmit() {
      this.$store.dispatch("userSignup", {
        email: this.email,
        password: this.password
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hidden {
  display: none;
}
.hero-body {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/user/Signup.vue